import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";
import { redirectTo, withShop } from "./web/style.js";

// Our products and the Co-op catalogue: one page, one product card, a switch between them (22/10/26; remade 29/10/26).
const ProductsPage = withShop(lazy(() => import("./web/catalogue/page.js").then((m) => ({ default: m.CataloguesPage }))));
const SettingsPage = withShop(lazy(() => import("./web/SettingsPage.js").then((m) => ({ default: m.SettingsPage }))));
const ScanPage = withShop(lazy(() => import("./web/ProductsPage.js").then((m) => ({ default: m.ScanPage }))));
const IssuesPage = withShop(lazy(() => import("./web/IssuesPage.js").then((m) => ({ default: m.IssuesPage }))));
const CategoriesPage = withShop(lazy(() => import("./web/CategoriesPage.js").then((m) => ({ default: m.CategoriesPage }))));
const DepartmentsPage = withShop(lazy(() => import("./web/DepartmentsPage.js").then((m) => ({ default: m.DepartmentsPage }))));
// New lines is a tab of Scan now (18/10/26); its old address still works.
const NewLinesPage = redirectTo("/products/scan?tab=new");

export default defineWebModule({ manifest, pages: { "": ProductsPage, "/scan": ScanPage, "/issues": IssuesPage, "/new": NewLinesPage, "/departments": DepartmentsPage, "/categories": CategoriesPage, "/settings": SettingsPage } });
